import React, { useEffect, useRef, useState } from 'react';
import Styled from '../styles/FVContents.styled';

import { IVideoPreviewFV } from '../interfaces/components/IVideoPreviewFV';
import { FaPlay } from 'react-icons/fa';
import { MdReplayCircleFilled } from 'react-icons/md';
import FVActionButtons from './FVActionsButton';
import { TfiReload } from 'react-icons/tfi';

const VideoPreviewFerramentaVideo: React.FC<IVideoPreviewFV> = ({
    videoUrl,
    capaUrl,
    isThumbnail,
    titleVideo,
    active,
    handleActive,
    handleDelete,
    handleEditForm,
    updateVideo,
    handleRefresh,
    isAdmin,
}) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const audioRef = useRef<HTMLAudioElement>(null);
    const [duration, setDuration] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(!!videoUrl);
    const [isPlaying, setIsPlaying] = useState<boolean>(false);
    const [mediaType, setMediaType] = useState<'video' | 'audio'>('video');

    // Detectar se é áudio ou vídeo baseado na extensão
    const detectMediaType = (url: string): 'video' | 'audio' => {
        if (!url) return 'video';
        const audioExtensions = ['.mp3', '.wav', '.m4a', '.aac', '.flac', '.ogg', '.weba'];
        const lowerUrl = url.toLowerCase();
        return audioExtensions.some(ext => lowerUrl.endsWith(ext)) ? 'audio' : 'video';
    };

    const handleLoadedMetadata = () => {
        if (mediaType === 'video' && videoRef.current) {
            setDuration(videoRef.current.duration);
        } else if (mediaType === 'audio' && audioRef.current) {
            setDuration(audioRef.current.duration);
        }
    };

    // Remove loading apenas quando o vídeo/áudio está pronto para reproduzir
    const handleCanPlay = () => {
        setIsLoading(false);
    };

    const handleError = () => {};

    const handlePlayClick = () => {
        setIsPlaying(true);
        setIsLoading(true);
        setTimeout(() => {
            if (mediaType === 'video' && videoRef.current) {
                videoRef.current.play();
            } else if (mediaType === 'audio' && audioRef.current) {
                audioRef.current.play();
            }
        }, 0);
    };

    const formatDuration = (seconds: number) => {
        const min = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60);
        return `${min}:${sec.toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        // Detecta o tipo de mídia
        const type = detectMediaType(videoUrl);
        setMediaType(type);

        // Reseta o estado de playing quando o videoUrl muda
        setIsPlaying(false);
        setIsLoading(false);

        // Se não temos duration, mas temos videoUrl, tenta pegar a duração
        if (videoUrl) {
            if (type === 'audio') {
                const tempAudio = document.createElement('audio');
                tempAudio.src = videoUrl;
                tempAudio.preload = 'metadata';
                tempAudio.onloadedmetadata = () => {
                    if (tempAudio.duration && tempAudio.duration > 0 && !isNaN(tempAudio.duration)) {
                        setDuration(tempAudio.duration);
                    }
                };
                tempAudio.onerror = () => {
                    setDuration(null);
                };
            } else {
                const tempVideo = document.createElement('video');
                tempVideo.src = videoUrl;
                tempVideo.preload = 'metadata';
                tempVideo.onloadedmetadata = () => {
                    if (tempVideo.duration && tempVideo.duration > 0 && !isNaN(tempVideo.duration)) {
                        setDuration(tempVideo.duration);
                    }
                };
                tempVideo.onerror = () => {
                    setDuration(null);
                };
            }
        } else {
            setDuration(null);
        }
    }, [videoUrl]);

    if (isThumbnail) {
        return (
            <Styled.VideoPreview.Thumbnail active={active} onClick={handleActive}>
                {active && (
                    <Styled.VideoPreview.TagPlay>
                        Ativo <FaPlay />
                    </Styled.VideoPreview.TagPlay>
                )}
                {videoUrl && duration && <Styled.VideoPreview.TagMinutagem>{formatDuration(duration)}</Styled.VideoPreview.TagMinutagem>}
                <img src={capaUrl} alt="Thumbnail" />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px', marginTop: '18px' }}>
                    <h2 dangerouslySetInnerHTML={{ __html: titleVideo }} />
                </div>
                {isAdmin && (
                    <div style={{ position: 'absolute', top: '30%', right: '-120px' }}>
                        <FVActionButtons
                            onDelete={handleDelete ? handleDelete : () => {}}
                            onEdit={handleEditForm ? handleEditForm : () => {}}
                            msgDelete="Tem certeza que deseja deletar este conteúdo?"
                        />
                    </div>
                )}
            </Styled.VideoPreview.Thumbnail>
        );
    }

    return (
        <Styled.VideoPreview.Container
            style={{
                position: 'relative',
                minHeight: '320px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
            }}
        >
            {isLoading && isPlaying && (
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2,
                    }}
                >
                    <div className="loaderConteudo" />
                </div>
            )}
            {isAdmin && (
                <>
                    <Styled.VideoPreview.ButtonUploadVideo onClick={updateVideo}>
                        Alterar mídia <MdReplayCircleFilled />
                    </Styled.VideoPreview.ButtonUploadVideo>
                    <Styled.VideoPreview.ButtonUploadVideo style={{ right: '10px' }} onClick={handleRefresh}>
                        <TfiReload size={22} />
                    </Styled.VideoPreview.ButtonUploadVideo>
                </>
            )}
            {!isPlaying && videoUrl && capaUrl ? (
                <div
                    onClick={handlePlayClick}
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        src={capaUrl}
                        alt="Video Cover"
                        style={{
                            width: '100%',
                            height: '420px',
                            objectFit: 'contain',
                            display: 'block',
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '80px',
                            height: '80px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            borderRadius: '50%',
                            zIndex: 2,
                        }}
                    >
                        <FaPlay size={32} color="white" />
                    </div>
                </div>
            ) : videoUrl ? (
                mediaType === 'audio' ? (
                    isPlaying && capaUrl ? (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px',
                                padding: '20px',
                                alignItems: 'center',
                            }}
                        >
                            <img
                                src={capaUrl}
                                alt="Audio Cover"
                                style={{
                                    width: '100%',
                                    maxWidth: '400px',
                                    height: '300px',
                                    objectFit: 'contain',
                                    borderRadius: '8px',
                                }}
                            />
                            <audio
                                key={videoUrl}
                                ref={audioRef}
                                controls
                                controlsList="nodownload"
                                onLoadedMetadata={handleLoadedMetadata}
                                onCanPlay={handleCanPlay}
                                onError={handleError}
                                style={{ width: '100%' }}
                                autoPlay
                            >
                                <source src={videoUrl} type="audio/mpeg" />
                                Seu navegador não suporta reprodução de áudio.
                            </audio>
                        </div>
                    ) : (
                        <div
                            onClick={handlePlayClick}
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: '100%',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src={capaUrl}
                                alt="Audio Cover"
                                style={{
                                    width: '100%',
                                    height: '420px',
                                    objectFit: 'contain',
                                    display: 'block',
                                }}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '80px',
                                    height: '80px',
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    borderRadius: '50%',
                                    zIndex: 2,
                                }}
                            >
                                <FaPlay size={32} color="white" />
                            </div>
                        </div>
                    )
                ) : (
                    <video
                        key={videoUrl}
                        ref={videoRef}
                        controls
                        controlsList="nodownload"
                        onLoadedMetadata={handleLoadedMetadata}
                        onCanPlay={handleCanPlay}
                        onError={handleError}
                        style={isLoading ? { visibility: 'hidden' } : { width: '100%' }}
                        autoPlay
                    >
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                )
            ) : (
                <div style={{ width: '100%', textAlign: 'center', color: '#003c78', fontSize: '1.2rem' }}>
                    {mediaType === 'audio' ? 'Áudio não disponível' : 'Vídeo não disponível'}
                </div>
            )}
        </Styled.VideoPreview.Container>
    );
};

export default VideoPreviewFerramentaVideo;
